import {
  API_ERROR,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
} from "./actionTypes";

// Updated to accept `navigate` instead of `history`
export const loginUser = (user, navigate) => {  // Accepting separate parameters
  return {
    type: LOGIN_USER,
    payload: { user, navigate },  // Passing separately in payload
  };
};

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

// Updated to accept `navigate` instead of `history`
export const logoutUser = (navigate) => {
  return {
    type: LOGOUT_USER,
    payload: { navigate }, // Pass navigate here
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
